'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import ViewIcon from "material-ui-icons/ViewModule";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../../../../..');

var _2 = _interopRequireDefault(_);

var _3 = require('..');

var _4 = _interopRequireDefault(_3);

var _DefaultValue = require('../../Fields/NamedField/DefaultValue');

var _DefaultValue2 = _interopRequireDefault(_DefaultValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Iterable = (_temp = _class = function (_EditorComponent) {
  _inherits(Iterable, _EditorComponent);

  function Iterable(props) {
    _classCallCheck(this, Iterable);

    return _possibleConstructorReturn(this, _EditorComponent.call(this, props));
  }

  Iterable.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content !== undefined ? content : _react2.default.createElement('div', {
      className: classes.panelButton
    }, 'Iterable'));
  }; // canBeParent(parent) {
  //   return parent instanceof ListView && super.canBeParent(parent);
  // }


  Iterable.prototype.renderMainView = function renderMainView() {
    var _getEditorContext2 = this.getEditorContext(),
        inEditMode = _getEditorContext2.inEditMode;

    return inEditMode ? _EditorComponent.prototype.renderMainView.call(this) : this.renderChildren();
  };

  Iterable.prototype.renderChildren = function renderChildren() {
    var _props = this.props,
        items = _props.items,
        ObjectContext = _props.ObjectContext;
    /**
     * Если не были переданы объекты или не был передан контекст,
     * возвращаем нативный результат.
     * Так сделано, потому что этот компонент может быть вставлен как в тело запроса (и выводить результаты из базы данных),
     * так и просто выводить дочерние элементы
     */

    var children = _EditorComponent.prototype.renderChildren.call(this);

    var childrenWithoutDefault = children.filter(function (n) {
      return n && n.type !== _DefaultValue2.default;
    });

    if (items === undefined || !ObjectContext) {
      // return children;
      return null;
    } else if (!items) {
      return null;
    } // else


    return items.length ? this.renderItems(items, childrenWithoutDefault) : children.filter(function (n) {
      return n && n.type === _DefaultValue2.default;
    });
  };

  Iterable.prototype.renderItems = function renderItems(items, children) {
    var _this2 = this;

    return items.map(function (n, index) {
      return _this2.renderItem(n, index, children);
    });
  };

  Iterable.prototype.renderItem = function renderItem(item, key, children) {
    var ObjectContext = this.props.ObjectContext;
    var id = item.id;
    return _react2.default.createElement(ObjectContext.Provider, {
      key: id || key,
      value: {
        object: item
      }
    }, children);
  };

  return Iterable;
}(_2.default), _class.Name = "Iterable", _class.propTypes = _extends({}, _2.default.propTypes, {
  items: _propTypes2.default.array,
  ObjectContext: _propTypes2.default.object
}), _temp);
exports.default = Iterable;
module.exports = exports['default'];